import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    palette: {
        default: {
            light: '#fff1bb',
            main: '#e0e0e0',
            dark: '#d5d5d5',
            contrastText: '#000000de',
        },
        yuzuPrimary: {
            main: '#fecd00',
        },
        primary: {
            light: '#fff1bb',
            main: '#fecd00',
            dark: '#e6ba02',
            contrastText: '#40474f',
        },
        secondary: {
            light: '#aaeb3b',
            main: '#9ad535',
            dark: '#8cd117',
            contrastText: '#ffffff',
            text: '#ffffff',
        },
        error: {
            light: '#ff7468',
            main: '#d2423d',
            dark: '#9a0016',
            contrastText: '#ffffff',
        },
    },
    typography: {
        p: {
            fontSize: '4rem',
        },
        // useNextVariants: true,
        // fontFamily: ['"Helvetica"', 'Arial', 'sans-serif'].join(','),
    },
    fontSize: 10,
    components: {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    letterSpacing: 0,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 3,
                    boxShadow: 'none',
                    fontSize: 14,
                    fontWeight: 'bold',
                    padding: '4px 10px',
                    letterSpacing: 0,
                    '&:hover': {
                        text: {
                            color: 'red',
                        },
                    },
                },
                text: {
                    width: 'inherit',
                    color: 'grey',
                    fontWeight: 'bolder',
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                // label: {
                //   width: 'inherit',
                // },
            },
        },
    },
    // fontSize: 10,
    // htmlFontSize: 10,
    // overrides: {
    //   fontSize: 6,
    //   MuiInputBase: {
    //     root: {
    //       color: '#4a4a4a',
    //     },
    //   },
    //   MuiButton: {
    //     root: {
    //       textTransform: 'none',
    //       borderRadius: 3,
    //       boxShadow: 'none',
    //       fontSize: 14,
    //       fontWeight: 'bold',
    //       padding: '0 10px',
    //     },
    //     text: {
    //       width: 'inherit',
    //       color: 'grey',
    //       fontWeight: 'bolder',
    //     },
    //     contained: {
    //       boxShadow: 'none',
    //       '&:hover': {
    //         boxShadow: 'none',
    //       },
    //     },
    //     label: {
    //       width: 'inherit',
    //     },
    //   },
    // },
});
export default theme;
